import React from 'react';
import '../../styles/styles.css';

export default function stotras() {
  return (
    
    <div className="container mt-4">
      <div className="row">
        {/* Left Large Image Box */}
        <div className="col-md-4 box1">
          <img src="/images/Ganesh.jpg" alt="Ganesh Stothras" />
        </div>

        {/* Right Information Boxes */}
        <div className="col-md-8 d-flex flex-column justify-content-center align-items-start gap-2">
  <button
    className="button1"
    onClick={() => window.open('/Downloads/Ganesh Pancharatna stotra.pdf', '_blank')}
  >
    Open Ganesh Pancharatna Stotra
  </button>

  <button
    className="button1"
    onClick={() => {
      const link = document.createElement('a');
      link.href = '/Downloads/Ganesh Pancharatna stotra.pdf';
      link.download = 'Ganesh Pancharatna stotra.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }}
  >
    Download Ganesh Pancharatna Stotra
  </button>
</div>



      </div>
    </div>

  )
}
